/* Native Shopify recommendations; exact matching pieces are rendered separately. */
if (!customElements.get('mci-recommendations')) {
  customElements.define('mci-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.querySelector('[data-recommendation-content]')) return;
      this.controller = new AbortController();
      const controller = this.controller;
      fetch(this.dataset.url, {signal: controller.signal})
        .then(response => { if (!response.ok) throw new Error('Recommendations unavailable'); return response.text(); })
        .then(html => {
          if (!this.isConnected || controller.signal.aborted) return;
          const content = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recommendation-content]');
          if (content) { this.replaceChildren(content); this.hidden = false; }
        }).catch(() => { /* Optional recommendations never block shopping. */ });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
